import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@/api/client';
import type { AdminFeedbackListResponse, AdminFeedback, FeedbackStatus } from '@/api/types';

export function useAdminFeedback(page = 1, limit = 20) {
    const params = new URLSearchParams({
        page: String(page),
        limit: String(limit),
    });

    return useQuery<AdminFeedbackListResponse>({
        queryKey: ['admin', 'feedback', page, limit],
        queryFn: () => api.get(`/api/admin/feedback?${params}`),
    });
}

export function useUpdateFeedbackStatus() {
    const queryClient = useQueryClient();

    return useMutation<AdminFeedback, Error, { feedbackId: number; status: FeedbackStatus }>({
        mutationFn: ({ feedbackId, status }) =>
            api.patch(`/api/admin/feedback/${feedbackId}/status`, { status }),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['admin', 'feedback'] });
        },
    });
}

export function useDeleteFeedback() {
    const queryClient = useQueryClient();

    return useMutation<{ success: boolean }, Error, number>({
        mutationFn: (feedbackId) =>
            api.delete(`/api/admin/feedback/${feedbackId}`),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['admin', 'feedback'] });
        },
    });
}
